module.exports = __webpack_public_path__ + "img/officialIco.5e5ccd9a.svg";